import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import historyIcon from "../../../assets/images/history-icon.svg";
import FormButton from "../../../Components/Buttons/FormButton";
import OffCanvas from "../../../Components/FormTag/OffCanvas";
import { inventoryStatusFinishedGoodsList } from "../../../Data/testData";
import PageHeader from "../../../Layout/PageHeader";
export default function StatusDetails() {
  const { id } = useParams<{ id: string }>();
  const pageName = `Item Code ${id}`;
  const navigate = useNavigate();
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };
  const handelCanvas = () => {
   setShowCanvas(!isShowCanvas);
  };

  const handelCancelBtn = () => {
    navigate("/inventory/status-overview")
  }
  const historyData = (
    <>
      <div
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const headerChildren = (
    <>
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Newest to oldest
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              Oldest to newest
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              {" "}
              Newest to oldest
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );



  return (
    <>
      <PageHeader
        listUrl="/inventory/status-overview"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="mt-2 bg-white rounded py-3 px-2">
        <div className="d-flex justify-content-between">
          <div className="ps-3 col-6 d-flex align-items-center text-black">
            {collapseStates[0] ? (
              <div className=" d-flex justify-content-between my-3 px-2 "></div>
            ) : (
              <div className=" d-flex justify-content-between px-2 ">
                <div>
                  <div className="fw-bold fs-15">Finished Goods</div>
                  {/* <label className="text-primary">20158</label> */}
                </div>
              </div>
            )}
          </div>
          {
            collapseStates[0] ? ("") : (
              <div className="d-flex col-4 justify-content-between py-2">
                <div>
                  <div className="label-light-grey fs-14">Total Bin Location</div>
                  <label>03</label>
                </div>
                <div>
                  <div className="label-light-grey fs-14">Total Quantity</div>
                  <label>25</label>
                </div>
              </div>
            )

          }
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(0)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>

        </div>
        {collapseStates[0] ? (
          <div className="checkin-details d-flex bg-white col-12 py-1 pb-4 px-2 justify-content-between ">
            <div className="col-12">
              <div className="flex-fill p-2 text-truncate fs-15 fw-bold">Finished Good</div>
              <div className="d-flex fw-bold px-3 col-12">
                <div className=" p-2 text-truncate fs-15 fw-bold col-2">Locations</div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  New Status
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Qty On Hand
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Transfer Qty
                </div>
              </div>
              {inventoryStatusFinishedGoodsList.map((item, index) => (
                <>
                  <div
                    key={index}
                    className={`d-flex px-3 py-2 rounded col-12 ${index % 2 === 0 ? 'odd-row-bg' : ''}`}>
                    <div className="p-2 text-truncate col-2">
                      {item.location}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      <select className="px-2 py-1 border border-secondary-subtle rounded w-100">
                        <option value="0">Select</option>
                        {item.optList.map((opItms) => (
                          <option value={opItms.value}>{opItms.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.qty}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.trfQty === "" ? <input type="text" className="border-0 border-bottom custom-input-border bg-transparent" /> : ""}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="mt-2 bg-white rounded py-3 px-2">
        <div className="d-flex justify-content-between">
          <div className="ps-3 col-6 d-flex align-items-center text-black">
            {collapseStates[1] ? (
              <div className=" d-flex justify-content-between my-3 px-2 "></div>
            ) : (
              <div className=" d-flex justify-content-between px-2 ">
                <div>
                  <div className="fw-bold fs-15">QC Hold</div>
                  {/* <label className="text-primary">20158</label> */}
                </div>
              </div>
            )}
          </div>
          {
            collapseStates[1] ? ("") : (
              <div className="d-flex col-4 justify-content-between py-2">
                <div>
                  <div className="label-light-grey fs-14">Total Bin Location</div>
                  <label>03</label>
                </div>
                <div>
                  <div className="label-light-grey fs-14">Total Quantity</div>
                  <label>25</label>
                </div>
              </div>
            )

          }
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(1)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          {/* <div className="d-flex col-4 justify-content-between py-2">
          <div>
            <div className="label-light-grey fs-14">Total Bin Location</div>
            <label>03</label>
          </div>
          <div>
            <div className="label-light-grey fs-14">Total Quantity</div>
            <label>25</label>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(1)}
            >
              {collapseStates[1] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          </div> */}
        </div>
        {collapseStates[1] ? (
          <div className="checkin-details d-flex bg-white col-12 py-1 pb-4 px-2 justify-content-between">
            <div className="col-12">
              <div className="flex-fill p-2 text-truncate fs-15 fw-bold">QC Hold</div>
              <div className="d-flex fw-bold px-3 col-12">
                <div className=" p-2 text-truncate fs-15 fw-bold col-2">Locations</div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  New Status
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Qty On Hand
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Transfer Qty
                </div>
              </div>
              {inventoryStatusFinishedGoodsList.map((item, index) => (
                <>
                  <div
                    key={index}
                    className={`d-flex px-3 py-2 rounded col-12 ${index % 2 === 0 ? 'odd-row-bg' : ''}`}>
                    <div className="p-2 text-truncate col-2">
                      {item.location}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      <select className="px-2 py-1 border border-secondary-subtle rounded w-100">
                        <option value="0">Select</option>
                        {item.optList.map((opItms) => (
                          <option value={opItms.value}>{opItms.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.qty}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.trfQty === "" ? <input type="text" className="border-0 border-bottom custom-input-border bg-transparent" /> : ""}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="mt-2 bg-white rounded py-3 px-2">
        <div className="d-flex justify-content-between">
          <div className="ps-3 col-6 d-flex align-items-center text-black">
            {collapseStates[2] ? (
              <div className=" d-flex justify-content-between my-3 px-2 "></div>
            ) : (
              <div className=" d-flex justify-content-between px-2 ">
                <div>
                  <div className="fw-bold fs-15">Damaged</div>
                  {/* <label className="text-primary">20158</label> */}
                </div>
              </div>
            )}
          </div>
          {
            collapseStates[2] ? ("") : (
              <div className="d-flex col-4 justify-content-between py-2">
                <div>
                  <div className="label-light-grey fs-14">Total Bin Location</div>
                  <label>04</label>
                </div>
                <div>
                  <div className="label-light-grey fs-14">Total Quantity</div>
                  <label>31</label>
                </div>
              </div>
            )
          }
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(2)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          {/* <div className="d-flex col-4 justify-content-between py-2">
          <div>
            <div className="label-light-grey fs-14">Total Bin Location</div>
            <label>04</label>
          </div>
          <div>
            <div className="label-light-grey fs-14">Total Quantity</div>
            <label>31</label>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(2)}
            >
              {collapseStates[2] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          </div> */}
        </div>
        {collapseStates[2] ? (
          <div className="checkin-details d-flex bg-white col-12 py-1 pb-4 px-2 justify-content-between">
            <div className="col-12">
              <div className="flex-fill p-2 text-truncate fs-15 fw-bold">Damaged</div>
              <div className="d-flex fw-bold px-3 col-12">
                <div className=" p-2 text-truncate fs-15 fw-bold col-2">Locations</div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  New Status
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Qty On Hand
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Transfer Qty
                </div>
              </div>
              {inventoryStatusFinishedGoodsList.map((item, index) => (
                <>
                  <div
                    key={index}
                    className={`d-flex px-3 py-2 rounded col-12 ${index % 2 === 0 ? 'odd-row-bg' : ''}`}>
                    <div className="p-2 text-truncate col-2">
                      {item.location}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      <select className="px-2 py-1 border border-secondary-subtle rounded w-100">
                        <option value="0">Select</option>
                        {item.optList.map((opItms) => (
                          <option value={opItms.value}>{opItms.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.qty}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.trfQty === "" ? <input type="text" className="border-0 border-bottom custom-input-border bg-transparent" /> : ""}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="mt-2 bg-white rounded py-3 px-2">
        <div className="d-flex justify-content-between">
          <div className="ps-3 col-6 d-flex align-items-center text-black">
            {collapseStates[3] ? (
              <div className=" d-flex justify-content-between my-3 px-2 "></div>
            ) : (
              <div className=" d-flex justify-content-between px-2 ">
                <div>
                  <div className="fw-bold fs-15">Reserved</div>
                  {/* <label className="text-primary">20158</label> */}
                </div>
              </div>
            )}
          </div>
          {
            collapseStates[3] ? ("") : (
              <div className="d-flex col-4 justify-content-between py-2">
                <div>
                  <div className="label-light-grey fs-14">Total Bin Location</div>
                  <label>06</label>
                </div>
                <div>
                  <div className="label-light-grey fs-14">Total Quantity</div>
                  <label>48</label>
                </div>
              </div>
            )

          }
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(3)}
            >
              {collapseStates[0] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          {/* <div className="d-flex col-4 justify-content-between py-2">
          <div>
            <div className="label-light-grey fs-14">Total Bin Location</div>
            <label>06</label>
          </div>
          <div>
            <div className="label-light-grey fs-14">Total Quantity</div>
            <label>48</label>
          </div>
          <div className="align-self-center">
            <span
              className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 me-3 mt-2"
              onClick={() => toggleCollapse(3)}
            >
              {collapseStates[3] ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          </div> */}
        </div>
        {collapseStates[3] ? (
          <div className="checkin-details d-flex bg-white col-12 py-1 pb-4 px-2 justify-content-between">
            <div className="col-12">
              <div className="flex-fill p-2 text-truncate fs-15 fw-bold">Reserved</div>
              <div className="d-flex fw-bold px-3 col-12">
                <div className=" p-2 text-truncate fs-15 fw-bold col-2">Locations</div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  New Status
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Qty On Hand
                </div>
                <div className="p-2 text-truncate text-center fs-15 fw-bold col-2">
                  Transfer Qty
                </div>
              </div>
              {inventoryStatusFinishedGoodsList.map((item, index) => (
                <>
                  <div
                    key={index}
                    className={`d-flex px-3 py-2 rounded col-12 ${index % 2 === 0 ? 'odd-row-bg' : ''}`}>
                    <div className="p-2 text-truncate col-2">
                      {item.location}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      <select className="px-2 py-1 border border-secondary-subtle rounded w-100">
                        <option value="0">Select</option>
                        {item.optList.map((opItms) => (
                          <option value={opItms.value}>{opItms.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.qty}
                    </div>
                    <div className="p-2 text-truncate text-center col-2">
                      {item.trfQty === "" ? <input type="text" className="border-0 border-bottom custom-input-border bg-transparent" /> : ""}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <div className="mt-5 bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={14}
            className="sph-btn me-4"
            handleClick={handelCancelBtn}
          >
            Update
          </FormButton>
          <FormButton
            tabIndex={15}
            className="sph-btn sph-shift me-4"
            handleClick={handelCancelBtn}
          >
            Cancel
          </FormButton>
        </div>
      </div>
      <OffCanvas
        show={isShowCanvas}
        handleClose={handelCanvas}
        title="HISTORY"
        headerChildren={headerChildren}
      ></OffCanvas>
    </>
  );
}
